export const rubricPersistSelectors = {
    questions: token => state => state.rubricPersist[token]?.questions || [],

    rubricQuestions: token => state => state.rubricPersist[token]?.rubricQuestions || [],

    currentStep: token => state => state.rubricPersist[token]?.currentStep || 0,

    unmatchedValuesPerQuestion: token => state => state.rubricPersist[token]?.unmatchedValuesPerQuestion || [],

    unmatchedValuesByQuestionIndex: (token, index) => state =>
        state.rubricPersist[token]?.unmatchedValuesPerQuestion?.[index] || null,
}
